import { CreditCard, Pix } from "@mui/icons-material";
import { Chip } from "@mui/material";

import { TransactionType } from "../../interfaces/transaction";

type PaymentMethodData = {
    icon: JSX.Element;
    label: string;
};

interface PaymentMethodLabelProps {
    value: TransactionType;
}

const paymentIcons: Record<TransactionType, PaymentMethodData> = {
    card: {
        icon: <CreditCard />,
        label: "Cartão",
    },
    pix: {
        icon: <Pix />,
        label: "PIX",
    },
};

export function PaymentMethodLabel({ value }: PaymentMethodLabelProps) {
    return (
        <Chip
            icon={paymentIcons[value].icon}
            label={paymentIcons[value].label}
            size="small"
            sx={{ borderRadius: 1 }}
        />
    );
}
